import { Button } from "antd";

const FirmUsersColumns = (goToUpdatePage, deleteFirmUser, isAdmin) => [
  {
    title: "Id",
    dataIndex: "userId",
    key: "userId",
    render: (value) => (
      <span style={{ textAlign: "center", display: "block" }}>{value}</span>
    ),
  },
  {
    title: "İsim",
    dataIndex: "name",
    key: "name",
    render: (value) => (
      <span style={{ textAlign: "center", display: "block" }}>{value}</span>
    ),
  },
  {
    title: "Soyisim",
    dataIndex: "surname",
    key: "surname",
    render: (value) => (
      <span style={{ textAlign: "center", display: "block" }}>{value}</span>
    ),
  },
  {
    title: "Tel",
    dataIndex: "phoneNumber",
    key: "phoneNumber",
    render: (value) => (
      <span style={{ textAlign: "center", display: "block" }}>{value}</span>
    ),
  },
  {
    title: "E-mail",
    dataIndex: "email",
    key: "email",
    render: (value) => (
      <span style={{ textAlign: "center", display: "block" }}>{value}</span>
    ),
  },

  {
    title: "Durum",
    dataIndex: "status",
    key: "status",
    render: (value) => (
      <span style={{ textAlign: "center", display: "block" }}>
        {value ? "Aktif" : "Pasif"}
      </span>
    ),
  },
  {
    title: "Rol",
    dataIndex: "firmRole",
    key: "firmRole",
    render: (value) => (
      <span style={{ textAlign: "center", display: "block" }}>
        {value.description}
      </span>
    ),
  },
  {
    title: "İşlemler",
    dataIndex: "operations",
    key: "operations",
    fixed: "right",
    render: (_, record) => (
      <div style={{ display: "flex" }}>
        <Button
          type="link"
          disabled={!isAdmin}
          onClick={() => goToUpdatePage({ record })}>
          Güncelle
        </Button>
        <Button
          type="link"
          disabled={!isAdmin}
          danger
          onClick={() => deleteFirmUser({ record })}>
          Sil
        </Button>
      </div>
    ),
  },
];

export { FirmUsersColumns };
